<template lang="pug">
  page
    section.header-section
      .container.info-container
        .row
          .col-sm-12.text-center
            h2 CORPORATE DEMAND WEEK
            p a joint initiative
            .nasscom
            .d-block
              ul.stats
                li
                  h3 6
                  p Corporates
                li
                  h3 5
                  p Business Days
                li
                  h3 15 
                  p Challenges
                li
                  h3 100+
                  p Startups
            //- h4 A Virtual Startup Expo by
            //- img.img-fluid.w-50(src="../../assets/img/ksumnasscom.png")
            .mt-5
              a.btn.btn-pill.btn-primary.mr-sm-3.mb-3.mb-sm-0(href="https://forms.zohopublic.com/keralastartupmission/form/EventRegistration11/formperma/BsK7CsuS2lorVw1F_ON86qP5Xj9N0YnoII9sRwldar4" target="_blank") Apply for Reverse Pitch
              a.btn.btn-pill.btn-info(href="https://business.startupmission.in/challenges" target="_blank") Apply for Challenges

    
    section.about-section
      .container
        h1 About
        p.text-justify Corporate Demand Week is a joint initiative by Kerala Startup Mission (KSUM) & NASSCOM Industry Partnership Program (NIPP) 
          | with the aim of connecting startups to the corporates. For startups, conscious early 
          | engagement with a relevant corporate can be a great way to present their product based on 
          | the exact requirement. With this purpose, KSUM & NIPP have come up with a specific 
          | program called CORPORATE DEMAND WEEK wherein corporates will showcase their challenges/problem statements to Kerala startups and then corporate- startups matchmaking process will be jointly facilitated by KSUM & NIPP.
          | Top sectors in this edition of corporate demand week are 
          b Fintech, Enterprise Tech, Mobility, Edutech.

        .arrow-container
          #zz.arrow-left-current
          #zz.arrow-ctr-current
            | Corporate Reverse pitching
          #zz.arrow-right-current
        .arrow-container
          #zz.arrow-left-current
          #zz.arrow-ctr-current
            | Application Invitation
          #zz.arrow-right-current

        .arrow-container
          #zz.arrow-left-current
          #zz.arrow-ctr-current
            | Screening and Shortlisting of Application
          #zz.arrow-right-current
        .arrow-container
          #zz.arrow-left-current
          #zz.arrow-ctr-current
            | Demo day with the selected startups
          #zz.arrow-right-current

        .arrow-container
          #zz.arrow-left-current
          #zz.arrow-ctr-current
            | Startup selection and engagement with corporate
          #zz.arrow-right-current


        //- p 
        //-   a(href="https://drive.google.com/file/d/1KR_7qnb5y6csMTdhGjefRzr0myaA2Vob/view?usp=sharing" target="_blank") How to Visit Stalls (User Manual)

    section.about-section
      .container
        .row.py-5.justify-content-center(v-if="current.weekdays")
          .col-sm-4.mt-3(v-for="(item,index) in current.weekdays")
            .grid-item
              .date
                h1 {{$moment(item.start).format('DD')}}
                h4 {{$moment(item.start).format('MMM YYYY')}}
              p {{item.name}}
              .detail
                router-link.button.btn.btn-warning(:to="{name:'weekday', params:{id:item.id}}" ) View Details
                //- counter(:name='"counter"+index' :start="item.start" v-else)
                //- v-if="active(item.start,item.end)"

        //- .row.pt-5#previous(v-if="weekdays.length")
        //-   .col-sm-12.mb-5
        //-     h1 Previous Demo Days
        //-   .col-sm-4(v-for="item in weekdays")
        //-     .card
        //-       .card-body
        //-         h3.mb-5.text-center {{item.name}}
        //-         .row
        //-           .col-6
        //-             .date
        //-               h1 {{$moment(item.start).format('DD')}}
        //-               h4 {{$moment(item.start).format('MMM YYYY')}}
        //-               i.feather-chevron-right
        //-           .col-6
        //-             .date
        //-               h1 {{$moment(item.end).format('DD')}}
        //-               h4 {{$moment(item.end).format('MMM YYYY')}}
        //-       .card-table
        //-         table.table.table-vcenter.mb-0
        //-           tr(v-for="day in item.weekdays")
        //-             td {{day.name}}
        //-             td.text-right
        //-               router-link.button.btn.btn-info.btn-sm.btn-pill(:to="{name:'weekday', params:{id:day.id}}") Visit


    section#partners
      .container
        h2.text-center.mb-5 Partners
        .row.justify-content-center.mb-5.pb-5
          .col-sm-2
            .card.card-sm
              .card-body
                img.img-fluid(src="../../assets/img/falabella.png")
          .col-sm-2
            .card.card-sm
              .card-body
                img.img-fluid(src="../../assets/img/credit.png")
          .col-sm-2
            .card.card-sm
              .card-body
                img.img-fluid(src="../../assets/img/psa-.png")
          .col-sm-2
            .card.card-sm
              .card-body
                img.img-fluid(src="../../assets/img/unilever.png")
          //- .col-sm-2
          //-   .card.card-sm
          //-     .card-body
          //-       img.img-fluid(src="../../assets/img/tata.png")
          .col-sm-2
            .card.card-sm
              .card-body
                img.img-fluid(src="../../assets/img/icici.png")
      
    section
      .container
        .row.justify-content-around
          .col-sm-5
            h2.text-center.mb-4 Timeline
            #timeline-box
              .timeline-item
                .date
                  h1 22
                  .month Nov 2020
                .card.card-sm
                  .card-body
                    h3 Application Deadline
              .card.card-sm
                .card-body
                  p.small.text-justify The Use cases shared by the corporates are posted on this platform. Against those use cases applications are  invited from the eligible startups with KSUM unique ID till 22nd November 2020
              .timeline-item.alter
                .date  
                  h1 25
                  .month Nov 2020
                .card.card-sm
                  .card-body  
                    h3 Prescreening
              .card.card-sm
                .card-body
                  p.small.text-justify KSUM & NIPP will do the first level screening of applications and the list will be shared to corresponding corporates for final shortlisting.
              .timeline-item
                .date
                  h1 05
                  .month Dec 2020
                .card.card-sm
                  .card-body
                    h3 Screening
              .card.card-sm
                .card-body
                  p.small.text-justify Further shortlisting/evaluation from the respective corporate. Post that a list of startups will be finalized with whom the demo day will be conducted.
              .timeline-item.alter
                .date
                  h1 14-19
                  .month Dec 2020
                .card.card-sm
                  .card-body
                    h3 Final Demo Day
              .card.card-sm
                .card-body
                  p.small.text-justify A date will be fixed for a demo day with corporates and corresponding selected startups against use cases. Demo day will be coordinated virtually, and startups will be given a time slot to pitch.
          .col-sm-6
            h2.text-center.mb-4 Focus Sectors
            .row.justify-content-center#focus
              .col-5
                .card.card-sm
                  .card-body
                    img.img-fluid(src="../../assets/img/fintech.png")
                    h3.text-center Fintech
              .col-5
                .card.card-sm
                  .card-body
                    img.img-fluid(src="../../assets/img/enterprise.png")
                    h3.text-center Enterprise Tech
              
              .col-5
                .card.card-sm
                  .card-body
                    img.img-fluid(src="../../assets/img/mobility.png")
                    h3.text-center Mobility

              .col-5
                .card.card-sm
                  .card-body
                    img.img-fluid(src="../../assets/img/edutech.png")
                    h3.text-center Edu Tech

    //- section#timeline-section.py-0
    //-   .container
    //-     h2.mb-5.text-center Timeline
    //-   ul.timeline
    //-     li.running
    //-       .timestamp
    //-         span.author November 1, 2020
    //-         span.date
    //-           | &nbsp;
    //-           span
    //-       .status
    //-         h4  Application Deadline
    //-     li
    //-       .timestamp
    //-         span.author November 4, 2020
    //-         span.date
    //-           | &nbsp;
    //-           span
    //-       .status
    //-         h4 Pre screening
    //-     li
    //-       .timestamp
    //-         span.author November 11, 2020
    //-         span.date
    //-           | &nbsp;
    //-           span
    //-       .status
    //-         h4  Final screening 
    //-     li
    //-       .timestamp
    //-         span.author November 16 to 20
    //-         span.date
    //-           | &nbsp;
    //-           span
    //-       .status
    //-         h4  Final Demo Day

    
    //- section.promo.pb-5.mb-5
    //-   .container
    //-     .row
    //-       .col-sm-12
    //-         h1 Sessions
    //-     .row
    //-       .col-sm-4
    //-         img.img-fluid(src="../../assets/img/chat-with-leader.jpg")
    //-         p.pt-3 Join the session Chat with Leader - Mr Venugopal Gupta, Director, ToiletBoard Coalition Accelerator Programme on June 29, 2020, 12pm to 1pm.
    //-         a.button.btn.btn-warning(href="https://www.airmeet.com/e/84d30fc0-b6b2-11ea-bc30-8fd9b946836d") Join Now

</template>

<script>
// @ is an alias to /src
import page from '@/components/frontend/page'
import pagination from '@/components/pagination';
import counter from '@/components/frontend/event_counter';
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DemoDay',
  components: {
    page,
    pagination,
    counter
  },
  data(){
    return {
      weekdays: [],
      current: {}
    }
  },
  computed:{
    ...mapState('api', ['sending']),
  },
  methods:{
    active(start,end){
      var today = this.$moment();
      var start_date = this.$moment(start);
      var end_date = this.$moment(end);
      if(today.isBefore(start_date)){
        return false;
      }
      else{
        return true;
      }

    },
    load_data(){
      var vm = this;
      this.call({ _vm: this, endpoint:'weekdays', method: 'POST' })
        .then((response)=>{
          vm.current = response.data.shift();
          vm.weekdays = response.data;
        });
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    this.load_data();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_mixins';

.arrow-container{
  display: inline-flex;
  // margin: 0 5px;
  margin-top: 40px;
  .arrow-left-current {
      display: inline-block;
      width: 0;
      height: 0;
      border-top: 40px solid #99afff;
      border-bottom: 40px solid #99afff;
      border-left: 40px solid transparent;
  }

  .arrow-ctr-current {
      display: inline-flex;
      width: 150px;
      background: #99afff;
      min-height: 80px;
      // line-height: 80px;
      position: relative;
      text-align: center;
      color: white;
      font-weight: 700;
      justify-content: center;
      align-items: center;
      padding: 0 5px;
  }

  .arrow-right-current {
      display: inline-block;
      height: 0;
      border-top: 40px solid transparent;
      border-bottom: 40px solid transparent;
      border-left: 40px solid #99afff;
      position: relative;
  }
}

.header-section{
  height: 100vh;
  background: url('../../assets/img/bg_nas.png');
  background-size: cover;
  background-position: top right;
  background-repeat: no-repeat;
  position: relative;
  @include my_bp(sm){
    background-size: contain;
    background-position-y: top;
    background-position-x: 50vw;
  }
  // &::after{
  //   background-image: linear-gradient(to bottom,transparent,rgba(9,6,11,.01) 3%,rgba(9,6,11,.05) 8%,rgba(9,6,11,.1) 13%,rgba(9,6,11,.15) 18%,rgba(9,6,11,.2) 23%,rgba(9,6,11,.25) 28%,rgba(9,6,11,.3) 33%,rgba(9,6,11,.35) 38%,rgba(9,6,11,.4) 43%,rgba(9,6,11,.45) 48%,rgba(9,6,11,.5) 53%,rgba(9,6,11,.55) 58%,#09060b 100%);
  //   content: "";
  //   display: block;
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   top: 20%;
  // }
  // .bottom-cover{
  //   background: url('../../assets/img/bottom.svg');
  //   height: 10vh;
  //   bottom: 0;
  //   position: absolute;
  //   width: 100%;
  //   background-size: cover;
  //   z-index:1;
  // }
  .info-container{
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #ffffff;
    @include my_bp(sm){
      color: #24292c;
    }
    h1{
      font-size: 5rem;
      font-weight: 400;
      // margin-bottom: 50px;
      // font-family: 'Pacifico';
    }
    h2{
      font-size: 3rem;;
    }
    h4{
      font-size: 1.5rem;
      font-weight: 200;
    }
    .nasscom{
      width: 60%;
      height: 100px;
      margin: 0 auto;
      background-image: url('../../assets/img/ksumnasscom-white.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: top center;
      @include my_bp(sm){
        background-image: url('../../assets/img/ksumnasscom.png');
      }
    }
  }
  ul.stats {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    
    @include my_bp(sm){
      margin-top: 2rem;
      height: 130px;
    }
    li {
      border: 1px dashed #ebebeb;
      border-radius: 4px;
      text-align: center;
      padding: 0.25rem;
      margin-bottom: 0.75rem;
      min-width: 130px;
      height: 100%;
      margin: .5rem .5rem;
      width: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #00afef55;
      transition: all 500ms ease;
      cursor: pointer;
      &:hover{
        background: #00afef;
        color: white;
        border: 1px solid #00afef;
        h3{
          color: white;
        }
      }
      @include my_bp(sm){
        background: transparent;
      }
      h3 {
        font-size: 3rem;
        color: #ffffff;
        margin-bottom: 0;
        transition: all 500ms ease;
        padding-top: 10px;
        @include my_bp(sm){
          color: #00afef;
        }
        span {
          font-size: .9rem;
          font-weight: 300;
        }
      }
      p {
        font-size: .9rem;
        // color: #24292c;
      }
    }
  }
}

.text-justify{
  text-align: justify;
}

.about-section{
  // padding-top: 80px;
  padding-bottom: 80px;
  .grid-item{
    transition: all 0.14s ease-in-out;
    border-radius: 0.25rem;
    border: 1px solid #e7eaf3;
    padding: 40px 20px;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 3px solid #328fe4;
    transition: all .5s ease;
    &:hover{
      box-shadow: 0 0 18px rgba(0,0,0,0.06);
      transform: translateY(-3px);
      background: #328fe4;
      color: white;
      border-bottom: 3px solid #fff900;
      h1{
        color: #fff900;
      }
      h4{
        color: #fff900;
      }
    }
    h1{
      font-size: 4rem;
      color: #328fe4;
      font-weight: 200;
    }
    .button{
      border-radius: 10rem;
    }
  }
}

#previous{
  .date{
    text-align: center;
    position: relative;
    i{
      position: absolute;
      top: -0.5rem;
      right: -2.5rem;
      font-size: 4rem;
      color: rgba(200,200,200,.5);
    }
    h1{
      font-size: 2rem;
      color: #328fe4;
      font-weight: 200;
    }
  }
}


#timeline-box{
  h1{
    color: #00afef;
    margin-bottom: 0;
  }
  h3{
    font-weight: 300;

  }
  .timeline-item{
    display: flex;
    align-items: center;
    &.alter{
      flex-direction: row-reverse;
      .card{
        margin-right: .5rem;
        margin-left: 0;
        text-align: left;
      }
    }
    &:hover{
      .date{
        background: white;
        color: #354052;
      }
      .card{
        background: #25363f;
        color: white;
        
      }
    }
    .date{
      border-radius: 50%;
      box-shadow: 2px 2px 10px rgba(0,0,0,.3);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 100px;
      background: #25363f;
      color: white;
      transition: all 500ms ease-in-out;
    }
    .card{
      margin-bottom: 0;
      flex-grow: 1;
      margin-left: .5rem;
      box-shadow: 2px 2px 10px rgba(0,0,0,.3);
      border:0;
      transition: all 500ms ease-in-out;
      text-align: right;
    }
  }
}

#partners{
  .card{
    box-shadow: 2px 2px 10px rgba(0,0,0,.3);
    transition: all 500ms ease-in;
    // &:hover{
    //   background: #24292c;
    //   img{
    //     filter: brightness(0) invert(1);
    //   }
    // }
  }
}

#focus{
  .card{
    box-shadow: 2px 2px 10px rgba(0,0,0,.3);
    transition: all 500ms ease-in;
    &:hover{
      background: #24292c;
      img{
        filter: brightness(0) invert(1);
      }
      h3{
        color: #fff;
      }
    }
  }
}
</style>